import { render, staticRenderFns } from "./PopupPosition.vue?vue&type=template&id=29464180&"
import script from "./PopupPosition.vue?vue&type=script&lang=js&"
export * from "./PopupPosition.vue?vue&type=script&lang=js&"
import style0 from "./PopupPosition.vue?vue&type=style&index=0&id=29464180&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports